import _MpSkeleton from "./MpSkeleton.jsx"
import withInstall from "../../utils/withInstall"
export const MpSkeleton = withInstall(_MpSkeleton)
export default MpSkeleton
